(function () {
  'use strict';

  // ── Thumbnail sync ──────────────────────────────────────────────────────────

  function setSecondThumbActive() {
    var thumbs = document.querySelectorAll('sht-slideshow-carousel-itm');
    if (thumbs.length < 2) return;
    var btn = thumbs[1].querySelector('.js-slideshow-btn-thumb');
    if (btn) btn.click();
  }

  // ── Shared price broadcast log ──────────────────────────────────────────────
  // PPLR writes the same raw price text into every .price-item--regular on the
  // page in one shot, then may immediately overwrite the PDP's own node again
  // (e.g. to add a customizer surcharge). The spillover guard needs the raw
  // broadcast value, not whatever the PDP node has moved on to since, so we
  // remember recent broadcasts here.

  var recentBroadcastPrices = [];

  function rememberBroadcastPrice(text) {
    if (!text) return;
    recentBroadcastPrices.push(text);
    if (recentBroadcastPrices.length > 5) recentBroadcastPrices.shift();
  }

  // ── Price structure restore ─────────────────────────────────────────────────
  // PPLR replaces the themed price HTML with plain text when recalculating.
  // We watch for that, then re-insert the original structure with the new amount.

  function initPriceSync() {
    var container = document.querySelector('.product__block-price');
    if (!container) return;

    var priceWrapper = container.querySelector('.js-product-price');
    if (!priceWrapper) return;

    var priceItem = priceWrapper.querySelector('.price-item--regular');
    if (!priceItem) return;

    // Save live references to all direct children (price wrapper, tax text, form, …)
    var children = Array.from(container.childNodes);

    var cfg = { childList: true };

    var observer = new MutationObserver(function () {
      // Only act when PPLR has removed our price wrapper
      if (container.contains(priceWrapper)) return;

      var newPrice = container.textContent.trim();
      if (!newPrice) return;

      rememberBroadcastPrice(newPrice);

      observer.disconnect();
      priceItem.textContent = newPrice;
      container.innerHTML = '';
      children.forEach(function (child) { container.appendChild(child); });
      observer.observe(container, cfg);
    });

    observer.observe(container, cfg);
  }

  // ── Price spillover guard ──────────────────────────────────────────────────
  // PPLR also writes its recalculated regular price into unrelated
  // .price-item--regular nodes elsewhere on the page.
  // We snapshot those nodes and only restore them when they are overwritten
  // with the current personalizer price, which is the signature of this bug.

  function initPriceSpilloverGuard() {
    var container = document.querySelector('.product__block-price');
    if (!container) return;

    var trackedPrices = [];
    var bodyCfg = {
      childList: true,
      characterData: true,
      subtree: true
    };
    var observer;

    function getPriceText(node) {
      return node && node.textContent ? node.textContent.trim() : '';
    }

    function getCurrentProductPriceText() {
      var currentPrice = container.querySelector('.price-item--regular');
      return getPriceText(currentPrice);
    }

    function isTracked(node) {
      return trackedPrices.some(function (entry) {
        return entry.node === node;
      });
    }

    function trackPrice(node) {
      if (!node || isTracked(node) || container.contains(node)) return;

      trackedPrices.push({
        node: node,
        html: node.innerHTML
      });
    }

    function trackPrices(root) {
      if (!root) return;

      if (root.nodeType === 1 && root.matches('.price-item--regular')) {
        trackPrice(root);
      }

      if (!root.querySelectorAll) return;

      root.querySelectorAll('.price-item--regular').forEach(function (node) {
        trackPrice(node);
      });
    }

    function revertIfSpilled(entry) {
      var currentPriceText = getCurrentProductPriceText();
      var nodePriceText = getPriceText(entry.node);

      // Matches either the price currently shown on the PDP, or a price PPLR
      // recently broadcast to every price node (which the PDP's own price may
      // have already moved past, e.g. after adding a customizer surcharge).
      var matchesCurrent = currentPriceText && nodePriceText === currentPriceText;
      var matchesBroadcast = recentBroadcastPrices.indexOf(nodePriceText) !== -1;

      if (!matchesCurrent && !matchesBroadcast) return;
      if (entry.node.innerHTML === entry.html) return;

      observer.disconnect();
      entry.node.innerHTML = entry.html;
      observer.observe(document.body, bodyCfg);
    }

    trackPrices(document.body);

    observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            trackPrices(node);
          });
        }
      });

      trackedPrices = trackedPrices.filter(function (entry) {
        return entry.node && entry.node.isConnected;
      });

      trackedPrices.forEach(revertIfSpilled);
    });

    observer.observe(document.body, bodyCfg);
  }

  // ── Translation ──────────────────────────────────────────────────────────
  // The PPLR app renders all of its own markup in German with no way to
  // translate it from the app settings. It also (re)injects markup on the
  // fly as the customer interacts with the widget, so a one-off pass isn't
  // enough — we keep translating via a MutationObserver, and guard against
  // re-triggering ourselves by only ever writing translated text once per
  // text node (tracked with a WeakSet).
  //
  // To add a new term: add one entry to PPLR_TRANSLATIONS below, keyed by
  // the exact German text as PPLR renders it.

  var PPLR_TRANSLATIONS = {
    'Beflockung': { en: 'Flocking', fr: 'Floquage' },
    'Ohne Flock': { en: 'No flocking', fr: 'Sans floquage' },
    'Spielerflock': { en: 'Player flocking', fr: 'Floquage joueur' },
    'Individuell': { en: 'Custom', fr: 'Personnalisé' },
    'Name': { en: 'Name', fr: 'Nom' },
    'Nummer': { en: 'Number', fr: 'Numéro' }
  };

  var translatedNodes = typeof WeakSet === 'function' ? new WeakSet() : null;

  function getPplrLocale() {
    var lang = (document.documentElement.lang || '').toLowerCase().split('-')[0];
    return (lang === 'en' || lang === 'fr') ? lang : null;
  }

  function translateTextNode(node, locale) {
    if (!node || node.nodeType !== 3) return;
    if (translatedNodes && translatedNodes.has(node)) return;

    var text = node.nodeValue.trim();
    if (!text) return;

    var entry = PPLR_TRANSLATIONS[text];
    if (!entry || !entry[locale]) return;

    node.nodeValue = node.nodeValue.replace(text, entry[locale]);
    if (translatedNodes) translatedNodes.add(node);
  }

  function translateElement(root, locale) {
    if (!root || root.nodeType !== 1) return;

    // Direct text-node children only, so we never touch nested elements
    // like the price span PPLR appends inside labels.
    Array.prototype.forEach.call(root.childNodes, function (child) {
      translateTextNode(child, locale);
    });

    Array.prototype.forEach.call(root.children || [], function (child) {
      translateElement(child, locale);
    });
  }

  var observedPplrRoots = typeof WeakSet === 'function' ? new WeakSet() : null;

  function initTranslation() {
    var locale = getPplrLocale();
    if (!locale) return; // German is the app's native language, leave as-is

    var pplr = document.querySelector('.product-personalizer');
    if (!pplr) return;

    translateElement(pplr, locale);

    // PPLR can rebuild its own root container from scratch, which would
    // silently orphan a MutationObserver attached to the old node. Guard
    // against attaching a second observer to the same still-live node.
    if (observedPplrRoots) {
      if (observedPplrRoots.has(pplr)) return;
      observedPplrRoots.add(pplr);
    }

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          translateTextNode(mutation.target, locale);
          return;
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 3) {
            translateTextNode(node, locale);
          } else if (node.nodeType === 1) {
            translateElement(node, locale);
          }
        });
      });
    });

    observer.observe(pplr, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  // ── Init ────────────────────────────────────────────────────────────────────

  function init() {
    var pplr = document.querySelector('.product-personalizer');
    if (!pplr) return;

    pplr.addEventListener('change', setSecondThumbActive);
    pplr.addEventListener('input', setSecondThumbActive);

    initPriceSync();
    initPriceSpilloverGuard();
    initTranslation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The app may rebuild/replace its root container after this initial
  // pass (e.g. on variant change); re-attach translation if so.
  window.addEventListener('pplrAppInitiated', initTranslation);
})();
